import { useDispatch, useSelector } from 'react-redux'
import { useCallback } from 'react'

import { NotificationController } from 'infraestructure/controllers/notificationController'
import { CreateNotificationsAsReadQueryRequest } from 'domain/entities/notifications'
import { Status } from 'domain/models/apiResponse'
import {
  createNotificationAsReadError,
  createNotificationAsReadStart,
  createNotificationAsReadSuccess,
  notificationsState,
} from 'presentation/redux/slices/notificationSlice'
import useError from 'presentation/hooks/useError'

export const useNotificationsAsRead = () => {
  const dispatch = useDispatch()
  const { isLoading, error } = useSelector(notificationsState)
  const { getErrorMessage } = useError()

  const createNotificationsAsRead = useCallback(
    async (data: CreateNotificationsAsReadQueryRequest) => {
      dispatch(createNotificationAsReadStart())
      try {
        const response = await NotificationController.markAsRead(data)
        if (response?.status === Status.success) {
          dispatch(createNotificationAsReadSuccess())
        }
      } catch (err: any) {
        dispatch(createNotificationAsReadError(getErrorMessage({ error: err })))
      }
    },
    [dispatch, getErrorMessage],
  )

  return { createNotificationsAsRead, isLoading, error }
}
